const country = [
  { countryCode: 'AC', name: 'Ascension Island', callingCode: '+247' },
  { countryCode: 'AD', name: 'Andorra', callingCode: '+376' },
  { countryCode: 'AE', name: 'United Arab Emirates', callingCode: '+971' },
  { countryCode: 'AF', name: 'Afghanistan', callingCode: '+93' },
  { countryCode: 'AG', name: 'Antigua And Barbuda', callingCode: '+1 268' },
  { countryCode: 'AI', name: 'Anguilla', callingCode: '+1 264' },
  { countryCode: 'AL', name: 'Albania', callingCode: '+355' },
  { countryCode: 'AM', name: 'Armenia', callingCode: '+374' },
  { countryCode: 'AO', name: 'Angola', callingCode: '+244' },
  { countryCode: 'AQ', name: 'Antarctica', callingCode: '+672' },
  { countryCode: 'AR', name: 'Argentina', callingCode: '+54' },
  { countryCode: 'AS', name: 'American Samoa', callingCode: '+1 684' },
  { countryCode: 'AT', name: 'Austria', callingCode: '+43' },
  { countryCode: 'AU', name: 'Australia', callingCode: '+61' },
  { countryCode: 'AW', name: 'Aruba', callingCode: '+297' },
  { countryCode: 'AX', name: 'Åland Islands', callingCode: '+358' },
  { countryCode: 'AZ', name: 'Azerbaijan', callingCode: '+994' },
  { countryCode: 'BA', name: 'Bosnia & Herzegovina', callingCode: '+387' },
  { countryCode: 'BB', name: 'Barbados', callingCode: '+1 246' },
  { countryCode: 'BD', name: 'Bangladesh', callingCode: '+880' },
  { countryCode: 'BE', name: 'Belgium', callingCode: '+32' },
  { countryCode: 'BF', name: 'Burkina Faso', callingCode: '+226' },
  { countryCode: 'BG', name: 'Bulgaria', callingCode: '+359' },
  { countryCode: 'BH', name: 'Bahrain', callingCode: '+973' },
  { countryCode: 'BI', name: 'Burundi', callingCode: '+257' },
  { countryCode: 'BJ', name: 'Benin', callingCode: '+229' },
  { countryCode: 'BL', name: 'Saint Barthélemy', callingCode: '+590' },
  { countryCode: 'BM', name: 'Bermuda', callingCode: '+1 441' },
  { countryCode: 'BN', name: 'Brunei Darussalam', callingCode: '+673' },
  {
    countryCode: 'BO',
    name: 'Bolivia, Plurinational State Of',
    callingCode: '+591'
  },
  {
    countryCode: 'BQ',
    name: 'Bonaire, Saint Eustatius And Saba',
    callingCode: '+599'
  },
  { countryCode: 'BR', name: 'Brazil', callingCode: '+55' },
  { countryCode: 'BS', name: 'Bahamas', callingCode: '+1 242' },
  { countryCode: 'BT', name: 'Bhutan', callingCode: '+975' },
  { countryCode: 'BW', name: 'Botswana', callingCode: '+267' },
  { countryCode: 'BY', name: 'Belarus', callingCode: '+375' },
  { countryCode: 'BZ', name: 'Belize', callingCode: '+501' },
  { countryCode: 'CA', name: 'Canada', callingCode: '+1' },
  { countryCode: 'CC', name: 'Cocos (Keeling) Islands', callingCode: '+61' },
  {
    countryCode: 'CD',
    name: 'Democratic Republic Of Congo',
    callingCode: '+243'
  },
  { countryCode: 'CF', name: 'Central African Republic', callingCode: '+236' },
  { countryCode: 'CG', name: 'Republic Of Congo', callingCode: '+242' },
  { countryCode: 'CH', name: 'Switzerland', callingCode: '+41' },
  { countryCode: 'CI', name: "Côte d'Ivoire", callingCode: '+225' },
  { countryCode: 'CK', name: 'Cook Islands', callingCode: '+682' },
  { countryCode: 'CL', name: 'Chile', callingCode: '+56' },
  { countryCode: 'CM', name: 'Cameroon', callingCode: '+237' },
  { countryCode: 'CN', name: 'China', callingCode: '+86' },
  { countryCode: 'CO', name: 'Colombia', callingCode: '+57' },
  { countryCode: 'CR', name: 'Costa Rica', callingCode: '+506' },
  { countryCode: 'CU', name: 'Cuba', callingCode: '+53' },
  { countryCode: 'CV', name: 'Cabo Verde', callingCode: '+238' },
  { countryCode: 'CW', name: 'Curacao', callingCode: '+599' },
  { countryCode: 'CX', name: 'Christmas Island', callingCode: '+61' },
  { countryCode: 'CY', name: 'Cyprus', callingCode: '+357' },
  { countryCode: 'CZ', name: 'Czech Republic', callingCode: '+420' },
  { countryCode: 'DE', name: 'Germany', callingCode: '+49' },
  { countryCode: 'DJ', name: 'Djibouti', callingCode: '+253' },
  { countryCode: 'DK', name: 'Denmark', callingCode: '+45' },
  { countryCode: 'DM', name: 'Dominica', callingCode: '+1 767' },
  { countryCode: 'DO', name: 'Dominican Republic', callingCode: '+1 809' },
  { countryCode: 'DO', name: 'Dominican Republic', callingCode: '+1 829' },
  { countryCode: 'DO', name: 'Dominican Republic', callingCode: '+1 849' },
  { countryCode: 'DZ', name: 'Algeria', callingCode: '+213' },
  { countryCode: 'EC', name: 'Ecuador', callingCode: '+593' },
  { countryCode: 'EE', name: 'Estonia', callingCode: '+372' },
  { countryCode: 'EG', name: 'Egypt', callingCode: '+20' },
  { countryCode: 'EH', name: 'Western Sahara', callingCode: '+212' },
  { countryCode: 'ER', name: 'Eritrea', callingCode: '+291' },
  { countryCode: 'ES', name: 'Spain', callingCode: '+34' },
  { countryCode: 'ET', name: 'Ethiopia', callingCode: '+251' },
  { countryCode: 'EU', name: 'European Union', callingCode: '+388' },
  { countryCode: 'FI', name: 'Finland', callingCode: '+358' },
  { countryCode: 'FJ', name: 'Fiji', callingCode: '+679' },
  { countryCode: 'FK', name: 'Falkland Islands', callingCode: '+500' },
  {
    countryCode: 'FM',
    name: 'Micronesia, Federated States Of',
    callingCode: '+691'
  },
  { countryCode: 'FO', name: 'Faroe Islands', callingCode: '+298' },
  { countryCode: 'FR', name: 'France', callingCode: '+33' },
  { countryCode: 'GA', name: 'Gabon', callingCode: '+241' },
  { countryCode: 'GB', name: 'United Kingdom', callingCode: '+44' },
  { countryCode: 'GD', name: 'Grenada', callingCode: '+473' },
  { countryCode: 'GE', name: 'Georgia', callingCode: '+995' },
  { countryCode: 'GF', name: 'French Guiana', callingCode: '+594' },
  { countryCode: 'GG', name: 'Guernsey', callingCode: '+44' },
  { countryCode: 'GH', name: 'Ghana', callingCode: '+233' },
  { countryCode: 'GI', name: 'Gibraltar', callingCode: '+350' },
  { countryCode: 'GL', name: 'Greenland', callingCode: '+299' },
  { countryCode: 'GM', name: 'Gambia', callingCode: '+220' },
  { countryCode: 'GN', name: 'Guinea', callingCode: '+224' },
  { countryCode: 'GP', name: 'Guadeloupe', callingCode: '+590' },
  { countryCode: 'GQ', name: 'Equatorial Guinea', callingCode: '+240' },
  { countryCode: 'GR', name: 'Greece', callingCode: '+30' },
  { countryCode: 'GT', name: 'Guatemala', callingCode: '+502' },
  { countryCode: 'GU', name: 'Guam', callingCode: '+1 671' },
  { countryCode: 'GW', name: 'Guinea-bissau', callingCode: '+245' },
  { countryCode: 'GY', name: 'Guyana', callingCode: '+592' },
  { countryCode: 'HK', name: 'Hong Kong', callingCode: '+852' },
  { countryCode: 'HN', name: 'Honduras', callingCode: '+504' },
  { countryCode: 'HR', name: 'Croatia', callingCode: '+385' },
  { countryCode: 'HT', name: 'Haiti', callingCode: '+509' },
  { countryCode: 'HU', name: 'Hungary', callingCode: '+36' },
  { countryCode: 'ID', name: 'Indonesia', callingCode: '+62' },
  { countryCode: 'IE', name: 'Ireland', callingCode: '+353' },
  { countryCode: 'IL', name: 'Israel', callingCode: '+972' },
  { countryCode: 'IM', name: 'Isle Of Man', callingCode: '+44' },
  { countryCode: 'IN', name: 'India', callingCode: '+91' },
  {
    countryCode: 'IO',
    name: 'British Indian Ocean Territory',
    callingCode: '+246'
  },
  { countryCode: 'IQ', name: 'Iraq', callingCode: '+964' },
  { countryCode: 'IR', name: 'Iran, Islamic Republic Of', callingCode: '+98' },
  { countryCode: 'IS', name: 'Iceland', callingCode: '+354' },
  { countryCode: 'IT', name: 'Italy', callingCode: '+39' },
  { countryCode: 'JE', name: 'Jersey', callingCode: '+44' },
  { countryCode: 'JM', name: 'Jamaica', callingCode: '+1 876' },
  { countryCode: 'JO', name: 'Jordan', callingCode: '+962' },
  { countryCode: 'JP', name: 'Japan', callingCode: '+81' },
  { countryCode: 'KE', name: 'Kenya', callingCode: '+254' },
  { countryCode: 'KG', name: 'Kyrgyzstan', callingCode: '+996' },
  { countryCode: 'KH', name: 'Cambodia', callingCode: '+855' },
  { countryCode: 'KI', name: 'Kiribati', callingCode: '+686' },
  { countryCode: 'KM', name: 'Comoros', callingCode: '+269' },
  { countryCode: 'KN', name: 'Saint Kitts And Nevis', callingCode: '+1 869' },
  {
    countryCode: 'KP',
    name: "Korea, Democratic People's Republic Of",
    callingCode: '+850'
  },
  { countryCode: 'KR', name: 'Korea, Republic Of', callingCode: '+82' },
  { countryCode: 'KW', name: 'Kuwait', callingCode: '+965' },
  { countryCode: 'KY', name: 'Cayman Islands', callingCode: '+1 345' },
  { countryCode: 'KZ', name: 'Kazakhstan', callingCode: '+7' },
  { countryCode: 'KZ', name: 'Kazakhstan', callingCode: '+7 6' },
  { countryCode: 'KZ', name: 'Kazakhstan', callingCode: '+7 7' },
  {
    countryCode: 'LA',
    name: "Lao People's Democratic Republic",
    callingCode: '+856'
  },
  { countryCode: 'LB', name: 'Lebanon', callingCode: '+961' },
  { countryCode: 'LC', name: 'Saint Lucia', callingCode: '+1 758' },
  { countryCode: 'LI', name: 'Liechtenstein', callingCode: '+423' },
  { countryCode: 'LK', name: 'Sri Lanka', callingCode: '+94' },
  { countryCode: 'LR', name: 'Liberia', callingCode: '+231' },
  { countryCode: 'LS', name: 'Lesotho', callingCode: '+266' },
  { countryCode: 'LT', name: 'Lithuania', callingCode: '+370' },
  { countryCode: 'LU', name: 'Luxembourg', callingCode: '+352' },
  { countryCode: 'LV', name: 'Latvia', callingCode: '+371' },
  { countryCode: 'LY', name: 'Libya', callingCode: '+218' },
  { countryCode: 'MA', name: 'Morocco', callingCode: '+212' },
  { countryCode: 'MC', name: 'Monaco', callingCode: '+377' },
  { countryCode: 'MD', name: 'Moldova', callingCode: '+373' },
  { countryCode: 'ME', name: 'Montenegro', callingCode: '+382' },
  { countryCode: 'MF', name: 'Saint Martin', callingCode: '+590' },
  { countryCode: 'MG', name: 'Madagascar', callingCode: '+261' },
  { countryCode: 'MH', name: 'Marshall Islands', callingCode: '+692' },
  {
    countryCode: 'MK',
    name: 'Macedonia, The Former Yugoslav Republic Of',
    callingCode: '+389'
  },
  { countryCode: 'ML', name: 'Mali', callingCode: '+223' },
  { countryCode: 'MM', name: 'Myanmar', callingCode: '+95' },
  { countryCode: 'MN', name: 'Mongolia', callingCode: '+976' },
  { countryCode: 'MO', name: 'Macao', callingCode: '+853' },
  {
    countryCode: 'MP',
    name: 'Northern Mariana Islands',
    callingCode: '+1 670'
  },
  { countryCode: 'MQ', name: 'Martinique', callingCode: '+596' },
  { countryCode: 'MR', name: 'Mauritania', callingCode: '+222' },
  { countryCode: 'MS', name: 'Montserrat', callingCode: '+1 664' },
  { countryCode: 'MT', name: 'Malta', callingCode: '+356' },
  { countryCode: 'MU', name: 'Mauritius', callingCode: '+230' },
  { countryCode: 'MV', name: 'Maldives', callingCode: '+960' },
  { countryCode: 'MW', name: 'Malawi', callingCode: '+265' },
  { countryCode: 'MX', name: 'Mexico', callingCode: '+52' },
  { countryCode: 'MY', name: 'Malaysia', callingCode: '+60' },
  { countryCode: 'MZ', name: 'Mozambique', callingCode: '+258' },
  { countryCode: 'NA', name: 'Namibia', callingCode: '+264' },
  { countryCode: 'NC', name: 'New Caledonia', callingCode: '+687' },
  { countryCode: 'NE', name: 'Niger', callingCode: '+227' },
  { countryCode: 'NF', name: 'Norfolk Island', callingCode: '+672' },
  { countryCode: 'NG', name: 'Nigeria', callingCode: '+234' },
  { countryCode: 'NI', name: 'Nicaragua', callingCode: '+505' },
  { countryCode: 'NL', name: 'Netherlands', callingCode: '+31' },
  { countryCode: 'NO', name: 'Norway', callingCode: '+47' },
  { countryCode: 'NP', name: 'Nepal', callingCode: '+977' },
  { countryCode: 'NR', name: 'Nauru', callingCode: '+674' },
  { countryCode: 'NU', name: 'Niue', callingCode: '+683' },
  { countryCode: 'NZ', name: 'New Zealand', callingCode: '+64' },
  { countryCode: 'OM', name: 'Oman', callingCode: '+968' },
  { countryCode: 'PA', name: 'Panama', callingCode: '+507' },
  { countryCode: 'PE', name: 'Peru', callingCode: '+51' },
  { countryCode: 'PF', name: 'French Polynesia', callingCode: '+689' },
  { countryCode: 'PG', name: 'Papua New Guinea', callingCode: '+675' },
  { countryCode: 'PH', name: 'Philippines', callingCode: '+63' },
  { countryCode: 'PK', name: 'Pakistan', callingCode: '+92' },
  { countryCode: 'PL', name: 'Poland', callingCode: '+48' },
  { countryCode: 'PM', name: 'Saint Pierre And Miquelon', callingCode: '+508' },
  { countryCode: 'PN', name: 'Pitcairn', callingCode: '+872' },
  { countryCode: 'PR', name: 'Puerto Rico', callingCode: '+1 787' },
  { countryCode: 'PR', name: 'Puerto Rico', callingCode: '+1 939' },
  {
    countryCode: 'PS',
    name: 'Palestinian Territory, Occupied',
    callingCode: '+970'
  },
  { countryCode: 'PT', name: 'Portugal', callingCode: '+351' },
  { countryCode: 'PW', name: 'Palau', callingCode: '+680' },
  { countryCode: 'PY', name: 'Paraguay', callingCode: '+595' },
  { countryCode: 'QA', name: 'Qatar', callingCode: '+974' },
  { countryCode: 'RE', name: 'Reunion', callingCode: '+262' },
  { countryCode: 'RO', name: 'Romania', callingCode: '+40' },
  { countryCode: 'RS', name: 'Serbia', callingCode: '+381' },
  { countryCode: 'RU', name: 'Russian Federation', callingCode: '+7' },
  { countryCode: 'RU', name: 'Russian Federation', callingCode: '+7 3' },
  { countryCode: 'RU', name: 'Russian Federation', callingCode: '+7 4' },
  { countryCode: 'RU', name: 'Russian Federation', callingCode: '+7 8' },
  { countryCode: 'RW', name: 'Rwanda', callingCode: '+250' },
  { countryCode: 'SA', name: 'Saudi Arabia', callingCode: '+966' },
  { countryCode: 'SB', name: 'Solomon Islands', callingCode: '+677' },
  { countryCode: 'SC', name: 'Seychelles', callingCode: '+248' },
  { countryCode: 'SD', name: 'Sudan', callingCode: '+249' },
  { countryCode: 'SE', name: 'Sweden', callingCode: '+46' },
  { countryCode: 'SG', name: 'Singapore', callingCode: '+65' },
  {
    countryCode: 'SH',
    name: 'Saint Helena, Ascension And Tristan Da Cunha',
    callingCode: '+290'
  },
  { countryCode: 'SI', name: 'Slovenia', callingCode: '+386' },
  { countryCode: 'SJ', name: 'Svalbard And Jan Mayen', callingCode: '+47' },
  { countryCode: 'SK', name: 'Slovakia', callingCode: '+421' },
  { countryCode: 'SL', name: 'Sierra Leone', callingCode: '+232' },
  { countryCode: 'SM', name: 'San Marino', callingCode: '+378' },
  { countryCode: 'SN', name: 'Senegal', callingCode: '+221' },
  { countryCode: 'SO', name: 'Somalia', callingCode: '+252' },
  { countryCode: 'SR', name: 'Suriname', callingCode: '+597' },
  { countryCode: 'SS', name: 'South Sudan', callingCode: '+211' },
  { countryCode: 'ST', name: 'Sao Tome and Principe', callingCode: '+239' },
  { countryCode: 'SV', name: 'El Salvador', callingCode: '+503' },
  { countryCode: 'SX', name: 'Sint Maarten', callingCode: '+1 721' },
  { countryCode: 'SY', name: 'Syrian Arab Republic', callingCode: '+963' },
  { countryCode: 'SZ', name: 'Swaziland', callingCode: '+268' },
  { countryCode: 'TA', name: 'Tristan de Cunha', callingCode: '+290' },
  {
    countryCode: 'TC',
    name: 'Turks And Caicos Islands',
    callingCode: '+1 649'
  },
  { countryCode: 'TD', name: 'Chad', callingCode: '+235' },
  { countryCode: 'TG', name: 'Togo', callingCode: '+228' },
  { countryCode: 'TH', name: 'Thailand', callingCode: '+66' },
  { countryCode: 'TJ', name: 'Tajikistan', callingCode: '+992' },
  { countryCode: 'TK', name: 'Tokelau', callingCode: '+690' },
  {
    countryCode: 'TL',
    name: 'Timor-Leste, Democratic Republic of',
    callingCode: '+670'
  },
  { countryCode: 'TM', name: 'Turkmenistan', callingCode: '+993' },
  { countryCode: 'TN', name: 'Tunisia', callingCode: '+216' },
  { countryCode: 'TO', name: 'Tonga', callingCode: '+676' },
  { countryCode: 'TR', name: 'Turkey', callingCode: '+90' },
  { countryCode: 'TT', name: 'Trinidad And Tobago', callingCode: '+1 868' },
  { countryCode: 'TV', name: 'Tuvalu', callingCode: '+688' },
  { countryCode: 'TW', name: 'Taiwan', callingCode: '+886' },
  {
    countryCode: 'TZ',
    name: 'Tanzania, United Republic Of',
    callingCode: '+255'
  },
  { countryCode: 'UA', name: 'Ukraine', callingCode: '+380' },
  { countryCode: 'UG', name: 'Uganda', callingCode: '+256' },
  {
    countryCode: 'UM',
    name: 'United States Minor Outlying Islands',
    callingCode: '+1'
  },
  { countryCode: 'US', name: 'United States', callingCode: '+1' },
  { countryCode: 'UY', name: 'Uruguay', callingCode: '+598' },
  { countryCode: 'UZ', name: 'Uzbekistan', callingCode: '+998' },
  { countryCode: 'VA', name: 'Vatican City State', callingCode: '+379' },
  { countryCode: 'VA', name: 'Vatican City State', callingCode: '+39' },
  {
    countryCode: 'VC',
    name: 'Saint Vincent And The Grenadines',
    callingCode: '+1 784'
  },
  {
    countryCode: 'VE',
    name: 'Venezuela, Bolivarian Republic Of',
    callingCode: '+58'
  },
  {
    countryCode: 'VG',
    name: 'Virgin Islands (British)',
    callingCode: '+1 284'
  },
  { countryCode: 'VI', name: 'Virgin Islands (US)', callingCode: '+1 340' },
  { countryCode: 'VN', name: 'Viet Nam', callingCode: '+84' },
  { countryCode: 'VU', name: 'Vanuatu', callingCode: '+678' },
  { countryCode: 'WF', name: 'Wallis And Futuna', callingCode: '+681' },
  { countryCode: 'WS', name: 'Samoa', callingCode: '+685' },
  { countryCode: 'XK', name: 'Kosovo', callingCode: '+383' },
  { countryCode: 'YE', name: 'Yemen', callingCode: '+967' },
  { countryCode: 'YT', name: 'Mayotte', callingCode: '+262' },
  { countryCode: 'ZA', name: 'South Africa', callingCode: '+27' },
  { countryCode: 'ZM', name: 'Zambia', callingCode: '+260' },
  { countryCode: 'ZW', name: 'Zimbabwe', callingCode: '+263' }
];

country.sort((c1, c2) => c1.name.localeCompare(c2.name));

export const getCountries = () => country;

export const getCountryFromCountryCode = countryCode => {
  const countries = getCountries();

  for (let i = 0; i < countries.length; i += 1) {
    if (countries[i].countryCode === countryCode) {
      return countries[i];
    }
  }

  return {};
};

export const getCountryFromCallingCode = callingCode => {
  const countries = getCountries();

  for (let i = 0; i < countries.length; i += 1) {
    if (countries[i].callingCode === callingCode) {
      return countries[i];
    }
  }

  return {};
};
